<script>
import { mergeData } from 'vue-functional-data-merge';

export default {
  functional: true,
  render (h, ctx) {
    ctx.children[0].data = mergeData(ctx.children[0].data, ctx.props.dataObject);
    return ctx.children[0];
  },
};
</script>
